/**
 * Modern Email Obfuscation for Shopify
 * Protects email addresses from bots while maintaining accessibility
 */

class EmailObfuscator {
  constructor() {
    this.init();
  }

  // Simple encoding function (you can make this more complex if needed)
  encode(str) {
    return btoa(str);
  }

  decode(str) {
    try {
      return atob(str);
    } catch (e) {
      return '';
    }
  }

  // Create mailto link from data attributes
  createMailtoLink(element) {
    const encodedEmail = element.dataset.email;
    const encodedSubject = element.dataset.subject || '';

    if (!encodedEmail) return;

    const email = this.decode(encodedEmail);
    const subject = encodedSubject ? this.decode(encodedSubject) : '';

    if (!email) return;

    // Build mailto URL
    let mailtoUrl = `mailto:${email}`;
    if (subject) {
      mailtoUrl += `?subject=${encodeURIComponent(subject)}`;
    }

    element.href = mailtoUrl;
    element.classList.remove('email-obfuscated');
    element.classList.add('email-revealed');
  }

  // Initialize all obfuscated email links
  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.processEmails());
    } else {
      this.processEmails();
    }
  }

  processEmails() {
    const obfuscatedLinks = document.querySelectorAll('a[data-email]');

    obfuscatedLinks.forEach(link => {
      this.createMailtoLink(link);

      // Add click event for additional protection
      link.addEventListener('click', (e) => {
        // Small delay to prevent automated clicking
        setTimeout(() => {
          if (!link.href.includes('mailto:')) {
            this.createMailtoLink(link);
          }
        }, 100);
      });
    });
  }

  // Static method to encode emails for template use
  static encodeEmail(email) {
    return btoa(email);
  }
}

// Initialize when script loads
new EmailObfuscator();

// Make encode function available globally for Liquid template use
window.EmailObfuscator = EmailObfuscator;
